const _global = (window /* browser */ || global /* node */) as any;

// define nameof<Class>('property')
const nameof = <T>(name: keyof T): string => String(name);
_global.nameof = nameof;

// global debounce function
// tslint:disable-next-line:no-var-keyword
var debounceTimeout: NodeJS.Timeout;
const debounce = (func: () => void, wait: number, immediate: boolean) => {
    return function () {
        const context = this, args = arguments;
        const later = function () {
            debounceTimeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && !debounceTimeout;
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
};
_global.debounce = debounce;
